import React from 'react';
import './index.css';

const Spinner = () => {
  return (
    <div className="overlay">
      <div className="spinner-container">
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default Spinner;
